var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 153,
    viewBox: "0 0 69 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 82.8203H33.3462C52.7257 82.8203 68.4359 98.5305 68.4359 117.91C68.4359 137.29 52.7257 153 33.3462 153H0V82.8203Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.000159341 0.000198364H21.8463C41.2258 0.000198364 56.9361 15.7104 56.9361 35.0899C56.9361 54.4695 41.2258 70.1797 21.8463 70.1797H0.000159341V0.000198364Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgB);
export default __webpack_public_path__ + "static/media/b.f2814fb8ff9789cf586f97f88e8eb2d8.svg";
export { ForwardRef as ReactComponent };